import React from 'react';
import { Switch } from 'react-router-dom';
import AppliedRoute from './components/Routes/AppliedRoute';
import PrivateRoute from './components/Routes/PrivateRoute';

import NotFound from './containers/Error/NotFound';
import Login from './containers/Auth/Login/Login';
import Signup from './containers/Auth/Signup/Signup';
import UserList from './containers/Auth/UserList/UserList';
import UserDetail from './containers/Auth/UserDetail/UserDetail';
import CustomProfile from './containers/CustomProfile/CustomProfile';
import GlobalProfile from './containers/CustomProfile/GlobalProfile';
import CustomProfileList from './containers/CustomProfile/CustomProfileList';
import ProfileDetail from './containers/CustomProfile/ProfileDetail';

import DeviceMap from './containers/DeviceMap/DeviceMap';
import DataReport from './containers/DataReport/DataReport';
import DataReportTrend from './containers/DataReportTrend/DataReportTrend';
import DataReportVehTrend from './containers/DataReportVehTrend/DataReportVehTrend';
import DeviceList from './containers/Devices/DeviceList/DeviceList';
import DeviceUpd from './containers/Devices/DeviceUpd/DeviceUpd';
import DeviceAnnualSubs from './containers/Devices/DeviceAnnualSubs/DeviceAnnualSubs'
import DeviceDetail from './containers/Devices/DeviceDetail/DeviceDetail';
import DeviceInfo from './containers/Devices/DeviceDetail/DeviceInfo';
import QueueDet from './containers/QueueDet/QueueDet';
import QueueDetTrend from './containers/QueueDetTrend/QueueDetTrend';
import SiteList from './containers/Sites/SiteList/SiteList';
import SiteDetail from './containers/Sites/SiteDetail/SiteDetail';
import RedLightSpeedDet from './containers/RedLightSpeedDet/RedLightSpeedDet';
import VehActiveTravel from './containers/VehActiveTravel/VehActiveTravel';
import SpeedReport from './containers/SpeedReport/SpeedReport';
import RadarConnection from './containers/RadarConnection/RadarConnection';
import AssetsConnections from './containers/AssetsConnections/AssetsConnections';



 const Routes = ({ childProps }) => {

	return (
	<Switch>
		<AppliedRoute path="/login" exact component={Login} props={childProps} />
		<PrivateRoute path="/signup" exact component={Signup} props={childProps} perm='add_users' />
		<PrivateRoute path="/users" exact component={UserList} props={childProps} perm='view_user_list' />
		<PrivateRoute path="/user_det/:id" exact component={UserDetail} props={childProps} perm='edit_users' />
		<PrivateRoute path="/custom_profile/" exact component={CustomProfileList} props={childProps} perm='edit_users' />
		<PrivateRoute path="/new_custom_profile/" exact component={CustomProfile} props={childProps} perm='edit_users' />
		<PrivateRoute path="/global_profile/" exact component={GlobalProfile} props={childProps} perm='edit_users' />
		<PrivateRoute path="/profile_det/:id" exact component={ProfileDetail} props={childProps} perm='edit_users' />
		<PrivateRoute path="/report" exact component={DataReport} props={childProps} perm='view_vehicle_detector' />
		<PrivateRoute path="/report_trend" exact component={DataReportTrend} props={childProps} perm='view_vehicle_det_trend' />
		<PrivateRoute path="/report_trend_veh" exact component={DataReportVehTrend} props={childProps} perm='view_vehicle_det_annual_trend' />
		<PrivateRoute path="/devices" exact component={DeviceList} props={childProps} perm='view_asset_list' />
		<PrivateRoute path="/devices_upd" exact component={DeviceUpd} props={childProps} perm='view_data_update' />
		<PrivateRoute path="/devices_as" exact component={DeviceAnnualSubs} props={childProps} perm='view_annual_subs' />
		<PrivateRoute path="/device_det" exact component={DeviceDetail} props={childProps} perm='view_asset' />
		<PrivateRoute path="/device_det/:id" exact component={DeviceDetail} props={childProps} perm='view_asset' />
		<PrivateRoute path="/device_info" exact component={DeviceInfo} props={childProps} perm='view_asset_info' />
		<PrivateRoute path="/device_info/:id" exact component={DeviceInfo} props={childProps} perm='view_asset_info' />
		<PrivateRoute path="/map" exact component={DeviceMap} props={childProps} perm='view_map' />
		<PrivateRoute path="/radars_connection" exact component={RadarConnection} props={childProps} perm='view_map' />
		<PrivateRoute path="/queue" exact component={QueueDet} props={childProps} perm='view_queue_detector' />
		<PrivateRoute path="/queue_trend" exact component={QueueDetTrend} props={childProps} perm='view_queue_det_trend' />
		<PrivateRoute path="/sites" exact component={SiteList} props={childProps} perm='view_asset_list' />
		<PrivateRoute path="/site_det" exact component={SiteDetail} props={childProps} perm='view_asset_list' />
		<PrivateRoute path="/site_det/:id" exact component={SiteDetail} props={childProps} perm='view_asset_list' />
		<PrivateRoute path="/device_add/:sid" exact component={DeviceDetail} props={childProps} perm='view_asset' />
		<PrivateRoute path="/red_light_speed" exact component={RedLightSpeedDet} props={childProps} perm='view_red_light_speed_detector' />	
		<PrivateRoute path="/veh_active_travel" exact component={VehActiveTravel} props={childProps} perm='view_veh_active_travel' />	
		<PrivateRoute path="/speed_report" exact component={SpeedReport} props={childProps} perm='view_speed_report' />	
		// Assets Connections
		<PrivateRoute path="/assets_connections" exact component={AssetsConnections} props={childProps} perm='view_asset_list' />	

		{/* message='This section is under construction' */}
		<PrivateRoute path="/" exact component={DeviceMap} props={childProps} />

		{/* Finally, catch all unmatched routes */}
		<AppliedRoute component={NotFound} props={childProps} message='Sorry, page not found!' />
	</Switch>
	)
 }

export default Routes;
